export default __webpack_public_path__ + "static/media/background.528e9f7c.jpg";